<template>
  <div>
    <NuxtLink
      class="flex flex-col items-center"
      :class="{
        'rounded-3xl border border-border-active px-3 py-2.5 transition-colors hover:border-border-hover': !props.showIcon,
      }"
      :to="{ path: hall.url, query: paramsForHall() }"
      :title="hall.name"
      @click="onClickRecommendedHall()"
    >
      <HallIcon v-if="props.showIcon" class="mb-1 size-16 text-icon-active" :name="computedIcon" />
      {{ hall.name }}
      <span v-if="hall.filterNames.length">
        {{ t['w.product.recommendedhalls.tagbegin']() }}
        <span v-for="(filterName, tagIndex) in hall.filterNames" :key="filterName">
          {{ filterName }}
          <span v-if="tagIndex !== hall.filterNames.length - 1">{{ t['w.product.recommendedhalls.tagseparator']() }}</span>
        </span>
        {{ t['w.product.recommendedhalls.tagend']() }}
      </span>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import HallIcon from '~/components/icon/HallIcon.vue'
import type { RecommendedHall as RecommendedHallType } from './recommended-hall-type'
import * as t from '~/messages'

const { proxy: gtmProxy } = useGtm()

const props = withDefaults(
  defineProps<{
    productCurrentPagePath?: string | null
    hall: RecommendedHallType
    index: number
    showIcon?: boolean
  }>(),
  {
    productCurrentPagePath: null,
    showIcon: true,
  }
)

const computedIcon = computed(() => props.hall.icon || 'legacy-' + props.hall.id)

const onClickRecommendedHall = () => {
  gtmProxy.dataLayer.push({
    event: 'hallClick',
    ecommerce: {
      click: {
        actionField: { list: 'Recommended Halls' },
        products: [
          {
            name: props.hall.name,
            id: props.hall.id,
            position: props.index + 1,
          },
        ],
      },
    },
  })
}

const paramsForHall = () => {
  const params: Record<string, string> = {}

  props.hall.params.forEach((p) => {
    params[`f${p.tagGroupId}`] = `${p.tagId}`
  })

  if (props.productCurrentPagePath) {
    params.previousProductPath = props.productCurrentPagePath
  }

  return params
}
</script>
